import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAllBorders } from '@ff-scene-plugins/photo-prints-redux/selectors/borderSelectors';
import { selectAllPapers } from '@ff-scene-plugins/photo-prints-redux/selectors/paperSelectors';
import { selectAllSizes } from '@ff-scene-plugins/photo-prints-redux/selectors/sizeSelectors';
import { selectHasMagicBorderApplied } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectVariantByGroupId } from '../../../../_redux-variants';
import styles from './SelectedVariantForOptionsGroup.module.scss';

export const SelectedVariantForOptionsGroup = ({ groupId }: { groupId: string }) => {

    const { t } = useTranslation();

    const variant = useSelector((state: PhotoPrintsPdpState) => selectVariantByGroupId(state, groupId));
    const hasMagicBorderApplied = useSelector((state: PhotoPrintsPdpState) => selectHasMagicBorderApplied(state, groupId));
    const sizes = useSelector(selectAllSizes);
    const papers = useSelector(selectAllPapers);
    const borders = useSelector(selectAllBorders);

    if (!variant || (sizes.length === 0 && papers.length === 0 && borders.length === 0)) {
        return <span></span>;
    }

    const size = sizes.length > 0 ? sizes.find(s => s.id === variant.sizeId) : undefined;
    const paper = papers.length > 0 ? papers.find(p => p.id === variant.paperId) : undefined;
    const border = borders.length > 0 ? borders.find(b => b.id === variant.borderId) : undefined;


    if (!size && !paper && !border) {
        return <span></span>;
    }

    const parts: string[] = [];

    if (size) {
        const sizeText = t(size.label, {
            widthInCm: size.width / 10,
            heightInCm: size.height / 10
        });
        parts.push(sizeText);
    }

    if (paper) {
        const paperText = t(paper.name);
        parts.push(paperText);
    }

    if (border && !hasMagicBorderApplied) {
        const borderText = t(border.name);
        parts.push(borderText);
    }

    if (hasMagicBorderApplied) {
        const fotofunName = t("photo_prints.photo_fun");
        parts.push(fotofunName);
    }

    if (parts.length === 0) {
        return <span></span>;
    }

    return (
        <span className={styles.variants}>
            {parts.join(' - ')}
        </span>
    );
};